import {styled} from "styled-components";

export const VLoyaltyContainer = styled.div`
    
    .custom-toolbar {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 10px 10px 10px 10px;

        .left-toolbar {
            display: flex;
            @media (max-width: 380px) {
                flex-direction: column;
            }

            .pageBtn {
                margin-right: 10px;
            }

            .columns-menu {
                display: flex;
                @media (max-width: 575.98px) {
                    margin-bottom: 5px;
                }
                @media (max-width: 380px) {
                    margin-top: 5px;
                }
            }
        }
    }

    .action-btn:focus {
        border: none !important;
    }

    .create-btn {
        background: #00a4e5;
        border-radius: 50%;
        padding: 6px;
        font-size: 10px;
        color: #fff;
        margin-left: 10px;

        &:hover {
            background-color: #0582c0;
            color: #fff;
            border: 1px solid #269bd5;
        }
    }

    .search-toolbar {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        @media (max-width: 575.98px) {
            width: 100%;
        }

        .search-bar {
            position: relative;
            @media (max-width: 575.98px) {
                width: 100%;
            }
        }

        .search-input {
            color: #707070;
            font-size: 15px;
            font-weight: 400;
            border: 1px solid #e5e7ef;
            border-radius: 5px;
            background-color: white;
            padding: 6px;
            padding-right: 34px;
            @media (max-width: 575.98px) {
                width: 100%;
            }
        }

        .search-icon {
            position: absolute;
            top: 8px;
            right: 10px;
            color: #707070;
        }
    }

    .selected-row-label {
        font-weight: 500;
        margin: 20px 0px 0px 10px;
    }
`;
